import { Toolbar } from '@mui/material'
import {
    Toolbar as ToolbarContainer,
    ToolbarPropsOverrides,
} from '@mui/x-data-grid'
import * as React from 'react'
import { SearchField } from '@/components/SearchField'

const seleniumPrefix = 'custom-admin-data-grid-toolbar'

declare module '@mui/x-data-grid' {
    interface ToolbarPropsOverrides {
        disabled?: boolean

        createButton: React.ReactNode

        initialSearchText?: string

        onChangeSearchText?: (searchText: string) => Promise<void> | void
    }
}

/**
 * Displayes a custom toolbar for `DataGrid`s, that includes a search input and a *new* button.
 */
export const CustomAdminDataGridToolbar: React.FC<ToolbarPropsOverrides> = ({
    disabled,
    createButton,
    initialSearchText,
    onChangeSearchText,
}) => {
    const [state, setState] = React.useState(initialSearchText ?? '')

    return (
        <ToolbarContainer style={{ minHeight: 66 }}>
            <Toolbar variant={'dense'} style={{ width: '100%' }}>
                <SearchField
                    disabled={disabled}
                    value={state}
                    onChange={async ({ target: { value } }) => {
                        setState(value)

                        await onChangeSearchText?.(value)
                    }}
                    onClickReset={async () => {
                        setState('')

                        await onChangeSearchText?.('')
                    }}
                    data-selenium={`${seleniumPrefix}-search-field`}
                />

                <div style={{ flex: 1 }} />

                {createButton}
            </Toolbar>
        </ToolbarContainer>
    )
}
